import styled from 'styled-components'

export const Wrapper = styled.span`
  button {
    background-color: #f0f0f0 !important;
    border-radius: 8px;
    width: 32px;
    padding: 0;
    color: #4c4c4c !important;
    svg {
      transition: 200ms;
    }
    &:hover {
      svg {
        opacity: 0.7;
      }
    }
    &:disabled {
      opacity: 0.48;
    }
  }
`
